import { partners } from '../../data/data';
import { PartherItem } from '../../types/types';
import Divider from '../../components/Divider/Divider';
const Partners = ({ startIndex }: { startIndex: number }) => {
  const slicedPartners = partners.slice(startIndex);
  return (
    <>
      <section className='partners'>
        <Divider />
        <div className='partners__container'>
          <h2 className='partners__title title color'>
            Our
            <span className='title'> Partners</span>
          </h2>
          <ul className='partners__list'>
            {slicedPartners.map((item: PartherItem) => (
              <li key={item.id} className={`partners__item`}>
                <img
                  className='partners__img'
                  src={item.img}
                  alt={item.title}
                />
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};
export default Partners;
